import { useState, useEffect, useRef } from "react";

function LeftTab({
  handleInputChange,
  formData,
  existingFeed,
  handleAddAsset,
  filterAsset,
  isLoading,
  error,
  brandNames,
  setSearchCategory,
  searchCategory,
  setSearchInput,
  searchInput,
  setFilterBrandName,
  filterBrandName,
  setFilter,
  filter,
}) {
  const [topPanelHeight, setTopPanelHeight] = useState(300); // Initial height in pixels
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef(null);

  console.table(filterAsset); // Debugging line

  const handleMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  useEffect(() => {
    console.log("filtered assets: ", filterAsset); // Debugging line
  }, []);

  // Handle mouse movement during drag
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isDragging) return;

      const containerRect = containerRef.current.getBoundingClientRect();
      const containerTop = containerRect.top;
      const containerHeight = containerRect.height;

      // Calculate new height based on mouse position
      const newHeight = Math.max(
        100,
        Math.min(
          e.clientY - containerTop,
          containerHeight - 100, // Ensure bottom panel has at least 100px
        ),
      );

      setTopPanelHeight(newHeight);
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    }

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging]);

  return (
    <div
      ref={containerRef}
      className="flex h-full w-1/3 flex-col overflow-hidden border-r border-gray-200"
    >
      {/* {filterAsset.map((asset, index) => (
        <div key={index} className="">
          <h1>Assety Title: {asset.AssetName}</h1>
        </div>
      ))} */}
      <div
        className="overflow-auto bg-white p-6 shadow-sm"
        style={{ height: `${topPanelHeight}px`, minHeight: "100px" }}
      >
        <h1 className="mb-6 text-2xl font-bold">
          {existingFeed ? "Edit Feed" : "New Feed"}
        </h1>

        <div className="rounded-lg bg-white p-6 shadow-sm">
          <h2 className="mb-6 text-lg font-semibold">Feed Settings</h2>
          <div className="space-y-4">
            <div>
              <label
                htmlFor="Name"
                className="mb-1 block text-sm font-medium text-gray-700"
              >
                Feed Name
              </label>
              <input
                type="text"
                id="Name"
                name="Name"
                value={formData.Name}
                onChange={handleInputChange}
                className="block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div>
                <label
                  htmlFor="SessionStartTime"
                  className="mb-1 block text-sm font-medium text-gray-700"
                >
                  Session Start Time
                </label>
                <input
                  type="datetime-local"
                  id="SessionStartTime"
                  name="SessionStartTime"
                  value={formData.SessionStartTime}
                  onChange={handleInputChange}
                  className="block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label
                  htmlFor="SessionEndTime"
                  className="mb-1 block text-sm font-medium text-gray-700"
                >
                  Session End Time
                </label>
                <input
                  type="datetime-local"
                  id="SessionEndTime"
                  name="SessionEndTime"
                  value={formData.SessionEndTime}
                  onChange={handleInputChange}
                  className="block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div>
                <label
                  htmlFor="MaxStarted"
                  className="mb-1 block text-sm font-medium text-gray-700"
                >
                  Max Started
                </label>
                <input
                  type="number"
                  id="MaxStarted"
                  name="MaxStarted"
                  value={formData.MaxStarted}
                  onChange={handleInputChange}
                  min="0"
                  className="block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label
                  htmlFor="MaxCompleted"
                  className="mb-1 block text-sm font-medium text-gray-700"
                >
                  Max Completed
                </label>
                <input
                  type="number"
                  id="MaxCompleted"
                  name="MaxCompleted"
                  value={formData.MaxCompleted}
                  onChange={handleInputChange}
                  min="0"
                  className="block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            {error && <div className="mt-2 text-sm text-red-600">{error}</div>}
          </div>
          <div className="mt-6 w-[200px] flex-1 justify-between">
            <label>
              <span className="mb-1 block text-sm font-medium text-gray-700">
                Feed Type
              </span>
            </label>
            <select
              onChange={handleInputChange}
              name="FeedType"
              value={formData.FeedType}
              className="block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="360">Regular</option>
              <option value="social_glass">Social Glass</option>
            </select>
          </div>
        </div>
        <div className="space-y-4">
          <h1 className="mb-6 mt-6 text-lg font-semibold">
            Asset Search and Filter
          </h1>

          <div className="flex gap-2">
            <select
              value={searchCategory}
              onChange={(e) => setSearchCategory(e.target.value)}
              className="rounded-md border border-gray-300 px-3 py-2"
            >
              <option value="caption">Caption</option>
              <option value="name">Asset Name</option>
            </select>
            <input
              type="text"
              placeholder={`Search by ${searchCategory}`}
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              className="flex-1 rounded-md border border-gray-300 px-3 py-2"
            />
          </div>

          <div className="flex gap-2">
            <select
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              className="flex-1 rounded-md border border-gray-300 px-3 py-2"
            >
              <option value="all">All Types</option>
              <option value="image">Images</option>
              <option value="video">Videos</option>
              <option value="poll">Polls</option>
              <option value="text">Text</option>
              <option value="post">Posts(social glass)</option>
            </select>

            <select
              value={filterBrandName}
              onChange={(e) => setFilterBrandName(e.target.value)}
              className="flex-1 rounded-md border border-gray-300 px-3 py-2"
            >
              <option value="all">All Brands</option>
              {brandNames.map((brand) => (
                <option key={brand} value={brand}>
                  {brand}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div
        className="flex h-2 cursor-row-resize items-center justify-center bg-gray-200 hover:bg-blue-300"
        onMouseDown={handleMouseDown}
      >
        <div className="h-1 w-8 rounded-full bg-gray-400"></div>
      </div>

      <div className="flex-1 overflow-y-auto bg-white p-6 shadow-md">
        <h2 className="mb-4 text-lg font-semibold">Available Assets</h2>
        {isLoading ? (
          <div className="py-4 text-center">Loading assets...</div>
        ) : error ? (
          <div className="py-4 text-center text-red-600">{error}</div>
        ) : (
          <div className="space-y-2">
            {filterAsset.map((asset, index) => (
              <div
                key={index}
                className="rounded-lg border border-gray-200 bg-white p-4 transition-shadow hover:shadow-md"
              >
                <div className="flex items-start justify-between">
                  <div>
                    <p className="font-medium">
                      {asset?.AssetName || "Sample Asset"}
                    </p>
                    <p className="text-sm text-gray-500">
                      {asset.Caption || "Sample caption"}
                    </p>
                    <p className="mt-1 text-xs text-gray-400">
                      {asset?.BrandName || "Brand"}
                    </p>
                  </div>
                  <button
                    onClick={() => handleAddAsset(asset)}
                    className="rounded-md bg-blue-50 px-3 py-1 text-sm text-blue-600 transition-colors hover:bg-blue-100"
                  >
                    Add
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default LeftTab;
